<template>
  <div class="middle-box text-center loginscreen">
    <div>
      <h3>Welcome to MIP CMS!</h3>
      <form class="m-t" role="form">
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            placeholder="Username"
            v-model="username"
            required
          />
        </div>
        <div class="form-group">
          <input
            type="password"
            class="form-control"
            placeholder="Password"
            v-model="password"
            required
          />
        </div>
        <div class="form-group">
          <div class="has-error" v-show="hasErrorMsg ">{{errorMsg}}</div>
        </div>
        <button class="btn btn-primary block full-width m-b" @click="login">Login</button>

        <a ui-sref="forgetPassword">
          <small>Forgot password?</small>
        </a>
      </form>
      <p class="m-t">
        <small>CP &copy; {{year}}</small>
      </p>
    </div>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
export default {
  mixins: [config.globalMixin],
  name: "loginController",
  data() {
    return {
      username: "",
      password: "",
      hasErrorMsg: true,
      errorMsg: "",
      year: "shijian"
    };
  },
  created: function() {
    var date = new Date();
    this.year = date.getFullYear();
  },
  methods: {
    async login(e) {
      e.preventDefault();
      let setLogin = this.setFormData({
        userName: this.username,
        password: this.password,
        lang:"en_US",
      });
      try {
        let data = await this.$store.dispatch("login", setLogin);
        if (data) {
          this.$router.push({ path: "/main/homePage" });
        }
      } catch (err) {
        var that = this;
        this.$store.commit("setwarning", {
          string: "Network Error. Please try again.",
          boolean: true,
          button: [{
            name:this.$i18n.t("message.Confirm"),
            callBack:function(){
              that.$store.commit("setwarning", {
                string: "",
                boolean: false,
              });
            }
          }]
        });
        console.error(err);
      }
    },
    assembleFunction: function(parentObj, list) {
      for (var i = 0; i < list.length; i++) {
        var childObj = list[i];
        if (parentObj.id == childObj.parentId) {
          if (parentObj.children) {
            parentObj.children.push(childObj);
          } else {
            parentObj.children = [];
            parentObj.children.push(childObj);
          }
          assembleFunction(childObj, list);
        }
      }
    }
  },
  mounted() {
    eventBus.$on(
      "warningBtn",
      function(name) {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: []
        });
      }.bind(this)
    );
  }
};
</script>

<style scoped>
</style>

